import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { baseUrl } from "../../utils/APi";
import { useTranslation } from "react-i18next";
import { getsubCategories } from "../../store/products/productAction";

import img1 from "../../assets/cat1.jpg";
import img2 from "../../assets/cat2.jpg";
import img3 from "../../assets/cat3.jpg";
import img4 from "../../assets/cat4.jpg";

import Bread from "../../component/Bread";

const Category = () => {
  // const dispatch = useDispatch();
  // const { t } = useTranslation();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { subCategory, loading } = useSelector((state) => state.Productslice);
  // const { id } = useParams();
  // useEffect(() => {
  //   if (id) {
  //    const promise = dispatch(getsubCategories({ lan, id: id }));
  //    return ()=>{
  //     promise.abort();
  //   }}
  // }, [lan, dispatch, id]);

  return (
    <Fragment>
    <Bread title={"Home"} sub={"Category"} />



    <section className="section-wrap category">
      <div className="container">
        <div className="row row-10">
          <div className="col-sm-6">
            <Link to={"/shop"} className="collection-item">
              <img src={img1} alt=""/>
              <div className="overlay">
                <h2 className="uppercase">Camera</h2>
              </div>
            </Link>
          </div>
          <div className="col-sm-6">
            <Link to={"/shop"} className="collection-item">
              <img src={img2} alt=""/>
              <div className="overlay">
                <h2 className="uppercase">Fire Alarm</h2>
              </div>
            </Link>
          </div>
          <div className="col-sm-6">
            <Link to={"/shop"} className="collection-item">
              <img src={img3} alt=""/>
              <div className="overlay">
                <h2 className="uppercase">Computers</h2>
              </div>
            </Link>
          </div>
          <div className="col-sm-6">
            <Link to={"/shop"} className="collection-item">
              <img src={img4} alt=""/>
              <div className="overlay">
                <h2 className="uppercase">Laptops</h2>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
</Fragment>
  );
};

export default Category;
